import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail, StickyNote, TrendingUp, MessagesSquare } from "lucide-react";

const ICON = { email: Mail, note: StickyNote, status_change: TrendingUp };
const TABS = [
  { k: "", label: "All" }, { k: "email", label: "Emails" },
  { k: "note", label: "Notes" }, { k: "status_change", label: "Status" },
];

export default function Communications() {
  const [type, setType] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/communications", { params: type ? { type } : {} }).then((r) => setRows(r.data));
  }, [type]);

  return (
    <div>
      <PageHeader title="Communication Center" subtitle="Every email, postcard, note and status change across your prospects." />
      <div className="mb-4 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.k} onClick={() => setType(t.k)} data-testid={`comm-tab-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${
              type === t.k ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <Card className="divide-y divide-slate-100">
        {rows.length === 0 && <div className="flex flex-col items-center gap-2 p-12 text-center text-slate-400"><MessagesSquare className="h-9 w-9" /><p className="text-sm">No communications yet.</p></div>}
        {rows.map((c) => {
          const Icon = ICON[c.type] || StickyNote;
          return (
            <div key={c.id} className="flex gap-3 p-4">
              <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-600"><Icon className="h-4 w-4" /></div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-sm font-semibold capitalize text-slate-800">{c.type.replace(/_/g, " ")}</span>
                  <span className="text-[11px] text-slate-400">{new Date(c.created_at).toLocaleString()}</span>
                </div>
                {c.subject && <div className="text-sm text-slate-700">{c.subject}</div>}
                {c.detail && <div className="text-sm text-slate-500">{c.detail}</div>}
                {c.body && <p className="mt-1 whitespace-pre-wrap text-xs text-slate-500 line-clamp-3">{c.body}</p>}
                <div className="mt-1 flex gap-2">
                  {c.phone && <span className="text-xs text-slate-400">{c.phone}</span>}
                  {c.status && <Badge variant="outline" className="text-[10px]">{c.status}</Badge>}
                </div>
              </div>
            </div>
          );
        })}
      </Card>
    </div>
  );
}
